import PropTypes from "prop-types";
import React from "react";
import { createUseStyles } from "react-jss";
import { Icon } from "rsuite";
import _ from "lodash";
import jssVariables from "../../jss_setup";

const failedPaymentStyles = createUseStyles({
  payment: {
    textAlign: "center",
    display: "grid",
    alignContent: "center",
    height: "100%",
    gridGap: `calc(${jssVariables.normal_gap} * 2)`,
    gridAutoRows: "max-content",
  },
  icon: { color: "orange" },
});

const FailedPayment = (props) => {
  const { paymentResult } = props;
  const classes = failedPaymentStyles();
  return (
    <div className={classes.payment}>
      <Icon className={classes.icon} icon="exclamation-triangle" size="5x" />
      <h4>
        {_.get(
          paymentResult,
          "error.message",
          "Payment failed. Please try again."
        )}
      </h4>
    </div>
  );
};

FailedPayment.propTypes = {
  paymentResult: PropTypes.object.isRequired,
};

export default FailedPayment;
